{
  "CAMPAIGN": {
    "LIVE_CHAT": {
      "HEADER_TITLE": "Live chat campaigns",
      "NEW_CAMPAIGN": "Create campaign",
      "CARD": {
        "STATUS": {
          "ENABLED": "Aktivert",
          "DISABLED": "Deaktivert"
        },
        "CAMPAIGN_DETAILS": {
          "SENT_BY": "Sendt av",
          "BOT": "Bot",
          "FROM": "fra",
          "URL": "URL:"
        }
      },
      "EMPTY_STATE": {
        "TITLE": "No live chat campaigns are available",
        "SUBTITLE": "Connect with your customers using proactive messages.  Click 'Create campaign' to get started."
      },
      "CREATE": {
        "TITLE": "Create a live chat campaign",
        "CANCEL_BUTTON_TEXT": "Avbryt",
        "CREATE_BUTTON_TEXT": "Opprett",
        "FORM": {
          "TITLE": {
            "LABEL": "Title",
            "PLACEHOLDER": "Please enter the title of campaign",
            "ERROR": "Title is required"
          },
          "MESSAGE": {
            "LABEL": "Melding",
            "PLACEHOLDER": "Please enter the message of campaign",
            "ERROR": "Message is required"
          },
          "INBOX": {
            "LABEL": "Select Inbox",
            "PLACEHOLDER": "Select Inbox",
            "ERROR": "Inbox is required"
          },
          "SENT_BY": {
            "LABEL": "Sendt av",
            "PLACEHOLDER": "Please select sender",
            "ERROR": "Sender is required"
          },
          "END_POINT": {
            "LABEL": "URL",
            "PLACEHOLDER": "Please enter the URL",
            "ERROR": "Vennligst skriv inn en gyldig URL",
            "URL_IS_REGEXP": "Verdien er et regulært uttrykk"
          },
          "TIME_ON_PAGE": {
            "LABEL": "Time on page(Seconds)",
            "PLACEHOLDER": "Please enter the time",
            "ERROR": "Time on page is required"
          },
          "OTHER_PREFERENCES": {
            "TITLE": "Other preferences",
            "ENABLED": "Enable campaign",
            "TRIGGER_ONLY_BUSINESS_HOURS": "Trigger only during business hours"
          },
          "BUTTONS": {
            "CREATE": "Opprett",
            "CANCEL": "Avbryt"
          },
          "API": {
            "SUCCESS_MESSAGE": "Live chat campaign created successfully",
            "ERROR_MESSAGE": "There was an error. Please try again."
          }
        }
      },
      "EDIT": {
        "TITLE": "Edit live chat campaign",
        "FORM": {
          "API": {
            "SUCCESS_MESSAGE": "Live chat campaign updated successfully",
            "ERROR_MESSAGE": "There was an error. Please try again."
          }
        }
      }
    },
    "SMS": {
      "HEADER_TITLE": "SMS campaigns",
      "NEW_CAMPAIGN": "Create campaign",
      "EMPTY_STATE": {
        "TITLE": "No SMS campaigns are available",
        "SUBTITLE": "Launch an SMS campaign to reach your customers directly. Send offers or make announcements with ease. Click 'Create campaign' to get started."
      },
      "CARD": {
        "STATUS": {
          "COMPLETED": "Completed",
          "SCHEDULED": "Scheduled"
        },
        "CAMPAIGN_DETAILS": {
          "SENT_FROM": "Sent from",
          "ON": "on"
        }
      },
      "CREATE": {
        "TITLE": "Create SMS campaign",
        "CANCEL_BUTTON_TEXT": "Avbryt",
        "CREATE_BUTTON_TEXT": "Opprett",
        "FORM": {
          "TITLE": {
            "LABEL": "Title",
            "PLACEHOLDER": "Please enter the title of campaign",
            "ERROR": "Title is required"
          },
          "MESSAGE": {
            "LABEL": "Melding",
            "PLACEHOLDER": "Please enter the message of campaign",
            "ERROR": "Message is required"
          },
          "INBOX": {
            "LABEL": "Select Inbox",
            "PLACEHOLDER": "Select Inbox",
            "ERROR": "Inbox is required"
          },
          "AUDIENCE": {
            "LABEL": "Audience",
            "PLACEHOLDER": "Select the customer labels",
            "ERROR": "Audience is required"
          },
          "SCHEDULED_AT": {
            "LABEL": "Scheduled time",
            "PLACEHOLDER": "Please select the time",
            "ERROR": "Scheduled time is required"
          },
          "BUTTONS": {
            "CREATE": "Opprett",
            "CANCEL": "Avbryt"
          },
          "API": {
            "SUCCESS_MESSAGE": "SMS campaign created successfully",
            "ERROR_MESSAGE": "There was an error. Please try again."
          }
        }
      }
    },
    "CONFIRM_DELETE": {
      "TITLE": "Er du sikker på at du vil slette?",
      "DESCRIPTION": "The delete action is permanent and cannot be reversed.",
      "CONFIRM": "Slett",
      "API": {
        "SUCCESS_MESSAGE": "Campaign deleted successfully",
        "ERROR_MESSAGE": "There was an error. Please try again."
      }
    }
  }
}
